import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { getToken, getOTP } from '@/utils/auth'

Vue.use(Vuex)
const auth_data = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_auth_data'))
if (getToken() && auth_data !== null) {
  auth_data.access_token = getToken()
}

export const store = new Vuex.Store({
  state: {
    disable_table: localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_disable_table') === 'true',
    qrmode: false,
    selected_type: JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_selected_type')),
    selected_store: null,
    selected_outlet: null,
    selected_id: JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_selected_id')),
    data_cart_reservation: JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_RESERVATION')),
    data_cart_take_away: JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_OL-TAKE-AWAY')),
    data_cart_delivery: JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DELIVERY')),
    data_cart_dinein: JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DINE-IN')),
    auth_data: auth_data,
    order_data: JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_order')),
    loading: false,
    loading_axios: false,
    data_verification: JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_verification')),
    type_verification: localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_type_verification'),
    otp_forget_password: getOTP(),
    block_location: false,
    block_camera: false,
    block_tooLong: false,
    must_allow_location: false,
    outside_radius: false,
    router_from: false,
    error_type: '',
    error_message: '',
    show_error: false,
    url_domain: '',
    store_astra: [
      'crematologycmpnymastra',
      'hobbybaksomenaraastra',
      'pepenerobakery',
      'harmonysalad',
      'dimsumcompany',
      'donburiichiya',
      'mangkuktulus',
      'rumaricaexpress',
      'putrikenanga',
      'magalexpress',
      'sairamen',
      'sotodudungroxy',
      'sahajapadang'
    ],
    store_tmii: [
      'bellafood',
      'berkahindonesia',
      'bogarasa',
      'buamoy',
      'bugissidrap',
      'dapoerdjiedahalim',
      'dapurbusam',
      'dapurtjikin',
      'dapuryenii',
      'davon',
      'dhiya',
      'elzipo',
      'gadogadobetawi',
      'gubugpecel',
      'heracatering',
      'ibutyia',
      'jengsri',
      'kantinandes',
      'kedaibuimat',
      'kedaifamily',
      'kiosalmahyramnr',
      'kopkartmii',
      'latiffood',
      'mascoco',
      'mbakmarti',
      'mpokjihan',
      'nailadimsum',
      'needsicecream',
      'nusantarafood',
      'pelangifood',
      'pelangi57',
      'pondokminang',
      'purworejofood',
      'rmsolo',
      'sekeco',
      'terasmina',
      'tongsengaslitegal',
      'umimadiun',
      'warungbetawi',
      'warungmarimampir',
      'wongrembang',
      'sab1',
      'sab2'
    ]
  },
  actions,
  mutations,
  getters
})
